import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, LinearProgress, MenuItem, TextField } from '@material-ui/core'
import { Edit } from '@material-ui/icons';
import React, { useState } from 'react'
import CloseIcon from '@material-ui/icons/Close';
import { useReportWritersAndReviewer, useUpdateReportWriter, } from '../../../common/CommonQueries';
import { toast } from 'react-toastify';
import { useFetchContext } from '../../../common/FetchContext';
import { Autocomplete } from '@material-ui/lab';


export const EditWriter = ({ id, name, refetch }: any) => {

    const [open, setOpen] = React.useState(false);
    const [reportWritter, setReportWritter] = useState('');
    const [reportReviewer, setReportReviewer] = useState('');
    const writerName = "report_writer_name"
    const reviewerName = "report_reviewer_name"

    const { mutateAsync: mutateReportWriter } = useUpdateReportWriter();
    const { authAxios } = useFetchContext();


    const {
        error: errorReportWriter,
        data: ReportWriterData = [],
        isLoading: isLoadingReportWirter,
        isError: isErrorReportWriter,
    } = useReportWritersAndReviewer();


    const handleClose = () => {
        setOpen(!open);
    };

    const handleReportWritter = (value: any) => {
        setReportWritter(value);
    };
    const handleReportReviewer = (value: any) => {
        setReportReviewer(value);
    };

    const handleSubmit = async () => {

        try {
            await mutateReportWriter({

                authAxios,
                report_result_id: id,
                reviewer_id: reportReviewer,
                writer_id: reportWritter

            })
            await refetch()

            toast.success("Report Writer Updated successfully!");
            setReportWritter("");
            handleClose();
        } catch (error: any) {
            console.error(error);
            toast.error("Error while Updating the report writer ", error);
        }

    }

    if (isLoadingReportWirter) {
        return (
            <>
                <LinearProgress />
            </>
        )
    }

    return (
        <>
            <Button
                color="primary"
                onClick={handleClose}
                // disabled={getTheme()}
                startIcon={<Edit />} />
            {name === writerName &&
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    fullWidth={false}
                >
                    <DialogTitle id="id">
                        <div>
                            <Box display="flex" alignItems="center">
                                <Box flexGrow={1} >{"Update Report Writer Info"}</Box>
                                <Box>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </Box>

                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <Divider variant="fullWidth" />
                        <Container >
                            <Grid
                                container
                                style={{ marginTop: 25 }}
                                direction="row"
                                justifyContent="space-around"
                                alignItems="center"
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    {/* <TextField
                                        id="reportWriter"
                                        name="reportWriter"
                                        label="Report Writer"
                                        select
                                        value={reportWritter}
                                        onChange={handleReportWritter}
                                        fullWidth
                                        margin="dense"
                                        data-testid="reportWriter"

                                    >
                                        {ReportWriterData.map((item: any) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.username}
                                            </MenuItem>
                                        ))}
                                    </TextField> */}

                                    <Autocomplete
                                        options={ReportWriterData}
                                        getOptionLabel={(option: any) => option.username || ""}
                                        value={
                                            ReportWriterData.find((item: any) => item.id === reportWritter) || null
                                        }
                                        onChange={(event, newValue) => {
                                            handleReportReviewer(newValue ? newValue.id : "");
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Report Writer"
                                                margin="dense"
                                                fullWidth
                                                data-testid="reportWriter"
                                            />
                                        )}
                                    />


                                </Grid>
                            </Grid>
                        </Container>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            data-testid="submit"
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            style={{ marginTop: "20px" }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            }

            {name === reviewerName &&
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    fullWidth={false}
                >
                    <DialogTitle id="id">
                        <div>
                            <Box display="flex" alignItems="center">
                                <Box flexGrow={1} >{"Update Report Reviewer Info"}</Box>
                                <Box>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </Box>

                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <Divider variant="fullWidth" />
                        <Container >
                            <Grid
                                container
                                style={{ marginTop: 25 }}
                                direction="row"
                                justifyContent="space-around"
                                alignItems="center"
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    {/* <TextField
                                        id="reportReviewer"
                                        name="reportReviewer"
                                        label="Report Reviewer"
                                        select
                                        value={reportReviewer}
                                        onChange={handleReportReviewer}
                                        fullWidth
                                        margin="dense"
                                        data-testid="reportReviewer"

                                    >
                                        {ReportWriterData.map((item: any) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.username}
                                            </MenuItem>
                                        ))}
                                    </TextField> */}

                                    <Autocomplete
                                        options={ReportWriterData}
                                        getOptionLabel={(option: any) => option.username || ""}
                                        getOptionSelected={(option: any, value: any) => option.id === value.id}
                                        value={
                                            ReportWriterData.find((item: any) => item.id === reportReviewer) || null
                                        }
                                        onChange={(event, newValue) => {
                                            handleReportReviewer(newValue ? newValue.id : "");
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Report Reviewer"
                                                margin="dense"
                                                fullWidth
                                                data-testid="reportReviewer"
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Container>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            data-testid="submit"
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            style={{ marginTop: "20px" }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            }

        </>
    )
}


